import { ApiService } from '../parents/api.service';
import { HttpApiClient } from '../api/http-api-client';

export class UploadsApiService extends ApiService {
  static endpoint = 'uploads';

  /**
   * @param {string} token
   * @param {object} data
   * @param {builderCallback} builderCallback
   * @param {object} config
   * @returns {Promise}
   * @public
   */
  static async uploadFile(token, data, builderCallback = null, config = {}) {
    return HttpApiClient.put(this.buildUrl(token), data, {
      ...config,
      dataModel: null,
      params: this.prepareUrlBuilder(builderCallback).getUrlParameters(),
    });
  }
}
